import React from 'react';

interface RoastBeansProps {
  roastCount: number;
}

const RoastBeans: React.FunctionComponent<RoastBeansProps> = ({
  roastCount
}: RoastBeansProps) => {
  const fullBeans: JSX.Element[] = roastCount && Array.from(Array(roastCount).keys()).map(int => {
    return <span className="bean" key={`roast-meta-${int + 2 * Math.random()}`}></span>;
  });

  const disabledBeans: JSX.Element[] = roastCount && Array.from(Array(5 - roastCount).keys()).map(int => {
    return <span className="bean bean-disabled" key={`roast-meta-${int + 2 * Math.random()}`}></span>;
  });

  if (!fullBeans && !disabledBeans) return null;

  return (
    <>
      {fullBeans}
      {disabledBeans}
    </>
  );
};

export default RoastBeans;